export const convertBytesToMegabytes = (numberOfKbs) => {
  return numberOfKbs / 1024 / 1024;
};
